<template>
  <div :ref="ref" :style="style" class="create-member">
    <el-form :model="oneData" ref="creatRef" :rules="creatRules" label-width="65px" label-position="left" style="width: 480px;">
      <el-form-item label="用户名" prop="username">
        <el-input placeholder="请输入用户名" v-model="oneData.username"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input placeholder="若不修改密码此项无需填写" type="password" v-model="oneData.password"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input placeholder="请输入手机号" maxlength="11" v-model.number="oneData.phone"></el-input>
      </el-form-item>
      <el-form-item label="角色组" prop="role">
        <el-select placeholder="请选择角色组" style="width: 100%;" v-model="oneData.role" clearable>
          <el-option v-for="item in roleOption" :label="item.label" :value="item.v" :key="item.v"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-radio v-model="oneData.sex" :label=1>男</el-radio>
        <el-radio v-model="oneData.sex" :label=2>女</el-radio>
      </el-form-item>
      <el-form-item label="所在地" class="location">
        <el-form-item prop="province_id">
          <el-select v-model="oneData.province_id" placeholder="选择省份" @change="changePro">
            <el-option
              v-for="item in province"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="city_id">
          <el-select v-model="oneData.city_id" placeholder="选择城市" @change="changeCity">
            <el-option
              v-for="item in city"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="area_id">
          <el-select v-model="oneData.area_id" placeholder="选择县/区">
            <el-option
              v-for="item in area"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" :rows="4" v-model="oneData.remak"></el-input>
      </el-form-item>
      <el-form-item style="text-align: right">
        <!--<el-button type="success" class="btn-default" @click="addAccount">新增账号</el-button>-->
        <template v-if="dislogHandle">
          <el-button type="info" @click="cancleModify">取消</el-button>
          <el-button type="success" class="btn-default">修改</el-button>
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  export default {
    name: 'member',
    props: {
      ref: {
        type: String,
        default: 'member'
      },
      width: {
        type: String,
        default: '480px'
      },
      oneData: {
        type: Object,
        default: {
          return: {
            username: '',
            password: '',
            phone: '',
            role: null,
            sex: 1,
            province_id: null,
            city_id: null,
            area_id: null,
            remak: ''
          }
        }
      }
    },
    data() {
      // 区/县自定义验证
      const areaValid = (rule, value, callback) => {
        let v = value.toString().trim();
        console.log(value);
        if (this.area != undefined) {
          console.log(v);
          if (v = '') {
            callback(new Error('请选择区/县'))
          } else {
            callback()
          }
        }
      };
      return {
        //取消、修改按钮显示隐藏
        dislogHandle: true,
        //获取当前用户权限
        nowRole: this.$Cookies.get('role'),
        // 角色组下拉
        roleOption: [
          {label: '超级管理员', v: 1},
          {label: '省份管理员', v: 2},
          {label: '市管理员', v: 3},
          {label: '区管理员', v: 4},
          {label: '普通操作人', v: 5},
        ],
        //创建账号表单
        //验证规则
        creatRules: {
          username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
          password: [{trigger: 'blur', validator: this.$Util.RegExp.passwordReg}],
          phone: [{required: true, trigger: 'blur', validator: this.$Util.RegExp.phoneReg}],
          role: [{required: true, message: '请选择角色组', trigger: 'blur'}],
          sex: [{required: true, trigger: 'blur'}],
          province_id: [{required: true, message: '请选择省', trigger: 'blur'}],
          city_id: [{required: true, message: '请选择市', trigger: 'blur'}],
          area_id: [{required: true, message: '请选择区', trigger: 'blur', validator: areaValid}],
        },
        //省
        provinceReq: {
          action: 'province',
          id: 0
        },
        cityReq: {
          action: 'city',
          id: 2
        },
        areaReq: {
          action: 'area',
          id: 36
        },
        province: [],
        city: [],
        area: []
      }
    },
    computed: {
      style() {
        let style = {};
        if (this.width) {
          style.width = this.width;
        }
        if (this.height) {
          style.height = this.height;
        }
        return style;
      }
    },
    methods: {
      //获取省市区
      getLocation(req) {
        this.$ajaxGet('/system/get_district', req).then(({data}) => {
          if (data.code === 1) {
            if (req.action === 'province') {
              this.province = data.data.result;
              this.oneData.province_id = this.province[0].id
            }
            if (req.action === 'city') {
              this.city = data.data.result;
              this.oneData.city_id = this.city[0].id
            }
            if (req.action === 'area') {
              this.area = data.data.result;
              if (this.area) {
                this.oneData.area_id = this.area[0].id
              } else {
                this.oneData.area_id = ''
              }
            }
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      // 省改变
      changePro(val) {
        this.cityReq.id = val;
        this.getLocation(this.cityReq);
        this.getLocation(this.areaReq);
      },
      //市改变
      changeCity(val) {
        this.areaReq.id = val;
        this.getLocation(this.areaReq);
        this.oneData.area_id = '';
      },
      //新增账号
      addAccount() {
        this.$refs.creatRef.validate(valid => {
          console.log(valid);
          if (valid) {
            this.$ajaxPost('/member/create', this.oneData).then(({data}) => {
              if (data.code == 1) {
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      },
      //获取用户信息
      getUserInfo(req) {
        this.$ajaxPost('/member/update', {id: 1}).then(data => {
          console.log(data);
        })
      },
      cancleModify() {
        this.$emit('show-hide', false)
      }
    },
    watch: {
      'oneData.city_id': function (val, oldVal) {
        this.areaReq.id = val;
        this.getLocation(this.areaReq);
      },
      'oneData.province_id':function (val,oldVal) {
        this.cityReq.id=val;
        this.getLocation(this.cityReq);
      }
    },
    components: {},
    mounted() {
      // console.log(this.$store.getters.page_buttons);
      // 获取省市区
      this.getLocation(this.provinceReq);
      this.getLocation(this.cityReq);
      this.getLocation(this.areaReq);
      this.getUserInfo();
      console.log(this.oneData);

    }
  }
</script>
<style lang="scss">
  #app .create-member {
    .el-form-item {
      margin-bottom: 20px;
    }
    .location {
      .el-form-item {
        width: 120px;
        margin-right: 27px;
        float: left;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Member/index.vue